module.exports = __webpack_public_path__ + "img/bao.1d6bc9b6.png";